export default __webpack_public_path__ + "static/Picto_bat_old-bf0e04c1c518b1f29d4f7196cb7eab34.jpg";